<template>
    <div>

        <!-- <div v-dialogDrag class="edit-know-box" v-if="openKeyword">
      <div class="edit-know-main">
        <i class="el-icon-close close-tag" @click="openKeyword=false"></i>
        <div>
            <div slot="title" class="dialog-header">
                <img class="collect-icon" src="@/assets/images/bookIcons/keyword3.png" alt="">
                <div class="collect-title">本页关键词</div>
                <div class="line-area"></div>
            </div>

          <div v-if="keywordList" class="keylist">
            <div v-for="(item,index) in keywordList" :key="index"  >
                <div @click="changeShow(item)">
                    <img v-if="!item.isShow" src="@/assets/images/bookIcons/smalldown.png" alt="" class="img">
                    <img v-else src="@/assets/images/bookIcons/smallup.png" alt="" class="img">
                    <div class="title">{{ item.keyword }} ({{ item.page.length }})</div>
                </div>
                <div v-if="!item.isShow" class="pages">
                    <div v-for="(item, index) in item.page" :key="index" class="page" @click="changePage(item)" >
                        {{ item.page}}
                    </div>
                </div>
            </div>
            </div>
            <div v-else>本页暂无关键词</div>
        </div>
      </div>
    </div> -->

        <el-dialog v-dialogDrag :visible.sync="openKeyword" class="comment-dialog" :modal-append-to-body="false"
            append-to-body :close-on-click-modal="false" :modal="false">
            <div style="display:flex">
                <div slot="title" class="dialog-header">
                    <img class="collect-icon" src="@/assets/images/bookIcons/keyword3.png" alt="">
                    <div class="collect-title">本页关键词</div>
                    <div class="line-area"></div>
                </div>
                <div slot="title" class="dialog-header">
                    <img class="collect-icon" src="@/assets/images/bookIcons/keyword3.png" alt="">
                    <div class="collect-title">本书关键词</div>
                    <div class="line-area"></div>
                </div>
            </div>
            <div style="display:flex">
                <div class="content">
                    <template v-if="keywordList">
                        <div v-for="(item, index) in keywordList" :key="index">
                            <div @click="changeShow(item)">
                                <img v-if="!item.isShow" src="@/assets/images/bookIcons/smalldown.png" alt="" class="img">
                                <img v-else src="@/assets/images/bookIcons/smallup.png" alt="" class="img">
                                <div class="title">{{ item.keyword }} ({{ item.page.length }})</div>
                            </div>
                            <div v-if="!item.isShow" class="pages">
                                <div v-for="(item, index) in item.page" :key="index" class="page" @click="changePage(item)">
                                    {{ item.page }}
                                </div>
                            </div>
                        </div>
                    </template>
                    <div v-else>本页暂无关键词</div>
                </div>
                <div class="content">
                    <template v-if="keywordAllList">
                        <div v-for="(item2, index2) in keywordAllList" :key="index2">
                            <div @click="changeShow2(item2)">
                                <img v-if="!item2.isShow" src="@/assets/images/bookIcons/smalldown.png" alt="" class="img">
                                <img v-else src="@/assets/images/bookIcons/smallup.png" alt="" class="img">
                                <div class="title">{{ item2.keyword }} ({{ item2.page.length }})</div>
                            </div>
                            <div v-if="!item2.isShow" class="pages">
                                <div v-for="(item2, index2) in item2.page" :key="index2" class="page"
                                    @click="changePage(item2)">
                                    {{ item2.page }}
                                </div>
                            </div>
                        </div>
                    </template>
                    <div v-else>本页暂无关键词</div>
                </div>
            </div>
        </el-dialog>

        <!-- <div v-dialogDrag class="edit-know-box" v-if="openKeywordAll">
      <div class="edit-know-main2">
        <i class="el-icon-close close-tag" @click="openKeywordAll=false"></i>
        <div>
            <div slot="title" class="dialog-header">
                <img class="collect-icon" src="@/assets/images/bookIcons/keyword3.png" alt="">
                <div class="collect-title">全书关键词</div>
                <div class="line-area"></div>
            </div>

          <div v-if="keywordList" class="keylist">
            <div v-for="(item,index) in keywordAllList" :key="index" >
                <div @click="changeShow(item)">
                    <img v-if="!item.isShow" src="@/assets/images/bookIcons/smalldown.png" alt="" class="img">
                    <img v-else src="@/assets/images/bookIcons/smallup.png" alt="" class="img">
                    <div class="title">{{ item.keyword }} ({{ item.page.length }})</div>
                </div>
                <div v-if="!item.isShow" class="pages">
                    <div v-for="(item, index) in item.page" :key="index" class="page" @click="changePage(item)">
                        {{ item.page}}
                    </div>
                </div>
            </div>
            </div>
            <div v-else>本书暂无关键词</div>
        </div>
      </div>
    </div> -->

        <!-- <el-dialog v-dialogDrag :visible.sync="openKeywordAll" class="all-dialog" :modal-append-to-body="false" append-to-body :close-on-click-modal="false" :modal="false">
            <div slot="title" class="dialog-header">
                <img class="collect-icon" src="@/assets/images/bookIcons/keyword3.png" alt="">
                <div class="collect-title">全书关键词</div>
                <div class="line-area"></div>
            </div>
            <template v-if="keywordList">
            <div v-for="(item,index) in keywordAllList" :key="index">
                <div @click="changeShow(item)">
                    <img v-if="!item.isShow" src="@/assets/images/bookIcons/smalldown.png" alt="" class="img">
                    <img v-else src="@/assets/images/bookIcons/smallup.png" alt="" class="img">
                    <div class="title">{{ item.keyword }} ({{ item.page.length }})</div>
                </div>
                <div v-if="!item.isShow" class="pages">
                    <div v-for="(item, index) in item.page" :key="index" class="page" @click="changePage(item)">
                        {{ item.page}}
                    </div>
                </div>
            </div>
            </template>
            <div v-else>本页暂无关键词</div>
        </el-dialog> -->
    </div>
</template>

<script>
export default {
  name: 'RetrieveDialogKeyword',
  props: {
    openKeyword: {
      type: Boolean,
      required: true
    },
    // openKeywordAll: {
    //   type: Boolean,
    //   required: true
    // },
    bookId: {
      type: String,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      keywordAllList: [],
      keywordList: []
    }
  },
  watch: {
    openKeyword () {
      this.$emit('closeKeyword', false)
    },
    // openKeywordAll () {
    //   this.$emit('closeKeywordAll', false)
    // },
    currentPage () {
      this.getKeyword()
    }
  },
  mounted () {
    this.getKeywordAll()
  },
  methods: {
    changeShow (item) {
      if (!item.isShow) {
        this.$set(item, 'isShow', false)
        item.isShow = !item.isShow
        this.$forceUpdate()
      } else {
        item.isShow = !item.isShow
        this.$forceUpdate()
      }
    },
    changeShow2 (item2) {
      if (!item2.isShow) {
        this.$set(item2, 'isShow', false)
        item2.isShow = !item2.isShow
        this.$forceUpdate()
      } else {
        item2.isShow = !item2.isShow
        this.$forceUpdate()
      }
    },
    getKeywordAll () {
      let params = new URLSearchParams()
      let url = 'retrieve/page/getKeywordAll'
      params.append('bookId', this.bookId)
      this.$http.post(url, params).then((res) => {
        console.log('res', res)
        if (res.status === 200 && res.data.status === 200) {
          var keywordList = res.data.data
          //   this.keywordList.forEach(item => {
          //     item.children.forEach(item2 => {
          //       item2.originPath = item2.originPath.split('/')[1].slice(0, -4)
          //     })
          //   })
          var reskey = []
          var narr = []
          this.keywordAllList = []
          for (var i = 0; i < keywordList.length; i++) {
            var n = reskey.indexOf(keywordList[i].keyword)
            if (n === -1) {
              reskey.push(keywordList[i].keyword)
              narr.push({ 'keyword': keywordList[i].keyword, 'page': [{ 'page': keywordList[i].page, 'pageId': keywordList[i].pageId }] })
            } else {
              narr[n].page.push({ 'page': keywordList[i].page, 'pageId': keywordList[i].pageId })
            }
          }
          this.keywordAllList = narr
          this.getKeyword()
          console.log('narr', this.keywordList)
        } else {
          this.$message({
            type: 'error',
            message: res.data
          })
        }
      })
    },
    getKeyword () {
      let params = new URLSearchParams()
      let url = 'retrieve/page/getKeyword'
      params.append('bookId', this.bookId)
      params.append('page', this.currentPage)
      this.$http.post(url, params).then((res) => {
        console.log('res', res)
        if (res.status === 200 && res.data.status === 200) {
          this.keywordList = []
          var keyword = res.data.data
          keyword.forEach(item => {
            this.keywordAllList.forEach(item2 => {
              if (item2.keyword === item.keyword) {
                this.keywordList.push(item2)
              }
            })
          })

          console.log('keyword', this.keywordList)
        } else {
          this.$message({
            type: 'error',
            message: res.data
          })
        }
      })
    },
    changePage (item) {
      this.currentPage = item.pageId
      console.log('key', item)
      this.$emit('changeCurrentPage', this.currentPage)
    }
  }
}
</script>

<style scoped>
.comment-dialog>>>.el-dialog {
    width: 585px !important;
    height: 571px !important;
    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    border: 1px solid #F7F6F5;
    margin-right: 360px;
    text-align: left;
}

.comment-dialog>>>.el-dialog__headerbtn {
    top: 5px !important;
    right: 4px;
    background: url('../assets/images/bookIcons/close.png') left no-repeat;
    background-size: cover;
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    width: 20px;
    height: 20px;
}

.comment-dialog ::-webkit-scrollbar {
    background-color: #f5eee8;
    width: 4px;
}

.comment-dialog ::-webkit-scrollbar-thumb {
    background-color: #9e5c1d;
}

.collect-icon {
    width: 16.19px;
    height: 15.79px;
}

.comment-dialog>>>.el-dialog__header {
    padding: 15px 0 0 16px;
}

.comment-dialog>>>.el-dialog__body {
    padding: 19px 11px 0 15px;
}

.collect-title {
    font-size: 18px;
    font-family: Source Han Sans CN-Bold, Source Han Sans CN;
    font-weight: bold;
    color: #9E5C1D;
    display: inline;
    margin: 0 0 13px 10px;
    bottom: 13px;
}

.content {
    width: 275px;
    padding: 5px;
    height: 475px;
    overflow: auto;
}

.dialog-header {
    width: 275px;
    padding: 5px;
}

.line-area {
    width: 115px;
    margin-top: 12px;
    border-bottom: 1px solid #9E5C1D;
}

.img {
    width: 14.14px;
}

.title {
    font-size: 16px;
    font-family: Source Han Sans CN-Bold, Source Han Sans CN;
    font-weight: bold;
    color: #634C37;
    line-height: 0px;
    display: inline;
    margin-left: 2px;
}

.pages {
    margin: 16px 0 22px 20px;
}

.page {
    display: inline;
    margin-right: 10px;
    font-size: 16px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #634C37;
    line-height: 0px;
    text-decoration: underline;
    cursor: pointer;
}</style>



// WEBPACK FOOTER //
// src/components/RetrieveDialogKeyword.vue